import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import cn from 'classnames';
import styles from './OfflineOverlay.module.scss';
import ViewMessage from '@components/ViewMessage';
import { OfflineIcon } from '@components/Icons';

export default function OfflineOverlay() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const setOnline = () => setIsOnline(true);
    const setOffline = () => setIsOnline(false);
    window.addEventListener('online', setOnline);
    window.addEventListener('offline', setOffline);
    return () => {
      window.removeEventListener('online', setOnline);
      window.removeEventListener('offline', setOffline);
    };
  }, []);

  return (
    <>
      {!isOnline &&
        createPortal(
          <div className={cn(styles.offlineOverlay)}>
            <ViewMessage
              icon={<OfflineIcon width={30} height={30} />}
              headline="No connection"
              message={
                <>
                  Clay requires a network connection. Please
                  <br />
                  connect your device to continue.
                </>
              }
            />
          </div>,
          document.querySelector('#offlineOverlay'),
        )}
    </>
  );
}
